import React from "react";

import "./styles.scss";
import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <div className="loader-gif-container">
      <Spinner animation="border" role="status" className="loader-spinner" />
    </div>
  );
};

export default Loader;
